export default __webpack_public_path__ + "static/media/cover-auth.eeb0c777.png";